import { Order as GraphQlOrder } from "@acto/gql/graphql";

export type OrderSummaryInput = Pick<GraphQlOrder, "billingDate" | "date" | "revenue">;

export default class OrderSummary {
  constructor(
    public readonly billingDate?: string,
    public readonly date?: string,
    public readonly revenue?: number,
  ) {}

  static fromGraphql(data?: OrderSummaryInput | null): OrderSummary | undefined {
    if (!data) return undefined;
    return new OrderSummary(data.billingDate ?? undefined, data.date ?? undefined, data.revenue ?? undefined);
  }
}
